import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import StarIcon from "@material-ui/icons/StarBorder";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Terms from "../Login/Terms.js";
import ALink from "@material-ui/core/Link";

const Copyright = () => (
    <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <Link color="inherit" href="https://material-ui.com/">
            HandsOn Booking
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
    </Typography>
);

const useStyles = makeStyles(theme => ({
    "@global": {
        ul: {
            margin: 0,
            padding: 0,
            listStyle: "none"
        }
    },
    appBar: {
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    toolbar: {
        flexWrap: "wrap"
    },
    toolbarTitle: {
        flexGrow: 1
    },
    link: {
        margin: theme.spacing(1, 1.5)
    },
    heroContent: {
        padding: theme.spacing(8, 0, 6)
    },
    cardHeader: {
        backgroundColor: theme.palette.type === "light" ? theme.palette.grey[200] : theme.palette.grey[700]
    },
    cardPricing: {
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
        marginBottom: theme.spacing(2)
    },
    footer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(8),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up("sm")]: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6)
        }
    }
}));

const tiers = [
    {
        title: "Light Version",
        price: "49",
        description: ["Manuel booking", "Journalføring", "Kalender", "Behandlingsliste", "App til mobiltelefon"],
        buttonText: "Vælg Abonnement",
        buttonVariant: "contained"
    },
    {
        title: "Pro Version",
        price: "149",
        description: [
            "Manuel booking",
            "Journalføring",
            "Kalender",
            "Behandlingsliste",
            "App til mobiltelefon",
            "Fakturering",
            "Online Booking",
            "E-mail og SMS",
            "Kurser",
            "Personligt layout",
            "Åbningstider"
        ],
        buttonText: "Vælg Abonnement",
        buttonVariant: "contained"
    }
];

export default props => {
    const classes = useStyles();
    const [terms, setTerms] = useState(false);
    return (
        <>
            <CssBaseline />
            <AppBar position="static" color="default" elevation={0} className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <Typography variant="h6" color="inherit" noWrap className={classes.toolbarTitle}>
                        HandsOn Booking
                    </Typography>
                    <Button
                        href="https://handsonbooking.dk"
                        color="primary"
                        variant="outlined"
                        className={classes.link}>
                        Gå til hjemmeside
                    </Button>
                </Toolbar>
            </AppBar>
            <Container maxWidth="sm" component="main" className={classes.heroContent}>
                <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                    Abonnement
                </Typography>
                <Typography variant="h5" align="center" color="textSecondary" component="p">
                    Om din prøveperiode er udløbet eller du blot ønsker at opgradere til HandsOn Booking Pro, så kan du
                    gøre det her.
                </Typography>
            </Container>
            <Container maxWidth="md" component="main">
                <Grid container spacing={5} alignItems="flex-start">
                    {tiers.map(tier => (
                        <Grid item key={tier.title} xs={12} sm={tier.title === "Enterprise" ? 12 : 6} md={6}>
                            <Card>
                                <CardHeader
                                    title={tier.title}
                                    subheader={tier.subheader}
                                    titleTypographyProps={{ align: "center" }}
                                    subheaderTypographyProps={{ align: "center" }}
                                    action={tier.title === "Pro" ? <StarIcon /> : null}
                                    className={classes.cardHeader}
                                />
                                <CardContent>
                                    <div className={classes.cardPricing}>
                                        <Typography component="h2" variant="h3" color="textPrimary">
                                            {tier.price}
                                        </Typography>
                                        <Typography variant="h6" color="textSecondary">
                                            /kr. pr. måned excl. moms
                                        </Typography>
                                    </div>
                                    <ul>
                                        {tier.description.map(line => (
                                            <Typography component="li" variant="subtitle1" align="center" key={line}>
                                                {line}
                                            </Typography>
                                        ))}
                                    </ul>
                                </CardContent>
                                <CardActions>
                                    <Button fullWidth variant={tier.buttonVariant} color="primary">
                                        {tier.buttonText}
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <Container maxWidth="md" component="footer" className={classes.footer}>
                <Grid container spacing={4} justify="space-evenly">
                    <ALink href="#" onClick={() => setTerms(true)}>
                        handelsbetingelser
                    </ALink>
                </Grid>
                <Box mt={5}>
                    <Copyright />
                </Box>
            </Container>
            <Terms open={terms} handleClose={() => setTerms(false)} />
        </>
    );
};
